/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {formatWithCurrencySymbol} from '../helper/financial-number-helper';
import {FinancialNumberCellValueModel} from '../model/financial-number-cell-value.model';

export function financialNumberPipe(cellValue: FinancialNumberCellValueModel): string {
    return formatWithCurrencySymbol(cellValue?.data, cellValue?.currency?.alphabeticCode);
}
